module.exports = __webpack_public_path__ + "WorkSans-Medium.eddbbc629def6aa23796.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Medium.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Medium.ttf
// module chunks = styles